import {
  AuctionResponse,
  PersonResponse,
} from '@bonhams1793/bonhams-typescript'
import { memo } from 'react'
import isEqual from 'react-fast-compare'

import { LotResponse } from '@nx/api'
import { FirePersonCard } from '@nx/fire/person-card'
import { buildSpecialistEmailSubject } from '@nx/helpers'

import { StyledFireCarousel } from './Contacts.styles'

export const Contacts = memo(
  ({ contacts, auction, lot, isFullWidth }: ContactsProps) => {
    return (
      <StyledFireCarousel
        fullWidthItems={isFullWidth ? 'always' : 'mobileOnly'}
      >
        {contacts.map(
          (
            { name, jobRole, image, contact: { email, phoneNumber } },
            index
          ) => (
            <FirePersonCard
              name={name}
              isAlwaysCompact={isFullWidth}
              jobRole={jobRole}
              imageUrl={image}
              nameTag="h3"
              phoneNumber={phoneNumber}
              emailAddress={email}
              emailSubject={buildSpecialistEmailSubject({
                auctionId: auction.iSaleNo,
                auctionStartDate: auction.dates.start[0].date.datetime,
                auctionEndDate: auction.dates.end.datetime,
                auctionTimezone: auction.dates.start[0].date.timezone.iana,
                auctionName: auction.sSaleName,
                lotId: lot?.iSaleLotNo,
                lotFullId: lot?.sSaleLotNoA,
                lotExhibition: lot?.lExhibition,
                lotDescription: lot?.sDesc,
              })}
              key={name + index}
            />
          )
        )}
      </StyledFireCarousel>
    )
  },
  isEqual
)

export interface ContactsProps {
  contacts: PersonResponse[]
  auction: AuctionResponse
  lot?: LotResponse
  isFullWidth?: boolean
}
